import React from 'react'
import PropTypes from 'prop-types'
import { Text, Flex } from 'pcln-design-system'
import IconRow from '../../../FareBrandBox/IconRow'
import DisplayPrice from '../../../DisplayPrice/DisplayPrice'
import { getAncillariesForIconRow, getIncludedAncillaries } from '../helpers'

const UpsellTrayCard = ({ upsell, priceColor, fareBrandBoxTexts }) => {
  const { name, ancillaries, pricing } = upsell
  const includedAncillaries = getIncludedAncillaries(ancillaries)
  const ancillariesForIconRow = getAncillariesForIconRow(ancillaries)

  const ancillariesString = includedAncillaries.map((anc, i) => [
    includedAncillaries.length > 2 && i > 0 && ', ',
    includedAncillaries.length >= 2 && i === includedAncillaries.length - 1 && ' and ',
    <Text.span key={anc} color='success' bold>
      {anc}
    </Text.span>,
    i === includedAncillaries.length - 1 && ' included',
  ])

  return (
    <Flex flexDirection='column' alignItems='center' justifyContent='space-between' height='100%'>
      <Flex flexDirection='column' alignItems='center'>
        <Text fontSize={1} bold mb={2} textAlign='center'>
          {name}
        </Text>

        {includedAncillaries.length > 0 && (
          <Text fontSize={0} mb={3} textAlign='center'>
            with {ancillariesString}
          </Text>
        )}
      </Flex>

      <Flex flexDirection='column' alignItems='center'>
        <DisplayPrice prefaceText={pricing.text} dollar={pricing.amount} color={priceColor} isResponsive />
        {fareBrandBoxTexts.map((text) => (
          <Text color='text.light' fontSize={0} key={text}>
            {text}
          </Text>
        ))}

        <IconRow
          ancillaries={ancillariesForIconRow}
          mt={0}
          visibility={ancillariesForIconRow.length > 0 ? 'visible' : 'hidden'}
          height='26px'
        />
      </Flex>
    </Flex>
  )
}

UpsellTrayCard.propTypes = {
  upsell: PropTypes.object,
  priceColor: PropTypes.string,
  fareBrandBoxTexts: PropTypes.array,
}

export { UpsellTrayCard }
